// role enums
export const ROLES = {
  ADMIN: 'admin',
  TRAVEL_GUIDER: 'travelGuider',
  MAINTAINER: 'maintainer',
  USER: 'user',
  SUPPER_ADMIN: 'super_admin',
  OWNER: 'owner',
};
